module.exports = __webpack_public_path__ + "static/media/Settings-2.06c90cf9.png";